import moment from 'moment';
import jQuery from 'jquery';
import _ from 'lodash';

import config from 'src/config';
import eventService from 'api/event';
import dateUtils from 'utils/dateUtils';

function Ctrl($scope, $rootScope, $timeout, $state, $stateParams, $location, $sce, utilsService, jsSdkVenue, jsSdkVenueInfo,
  jsSdkEvent, jsSdkCuratedList, imgix, $http, modalService, $filter, fb, loggerService, favoritesService, metaTagService,
  trackingService, jsSdkConfig, partnerService, $window) {
  $scope.venue = {};

  $scope.showBackBtn = !!$stateParams.back;
  $scope.backId = $stateParams.back;
  $scope.backName = $stateParams.backName;

  function _listInfo(venueId) {
    const options = {
      fields: 'key,title,enable'
    };

    jsSdkVenueInfo.listByVenueId(venueId, options)
      .then(function _success(resp) {
        const infoPageOrder = {
          about: 1,
          'table-service': 2,
          'bottle-service': 3,
          'guest-list': 4,
          'vip-list': 5,
          tickets: 6,
          'cover-charge': 7
        };

        $scope.venueInfo = _.sortBy(resp, function(page) {
          return infoPageOrder[page.key] || 99;
        });
      }, function _error(err) {

        $scope.venueInfo = null;

        loggerService.error(err);
      });
  }

  let venueIdOrSlug;

  if ($stateParams.seoPathname) {
    venueIdOrSlug = $stateParams.seoPathname.split('-').pop();
  } else if ($stateParams.name) {
    venueIdOrSlug = $stateParams.name;
  }

  if (!venueIdOrSlug) {
    $state.go('app.404');
    return;
  }

  $scope.venueImage = function(src) {
    if (!src) return '';

    return imgix.url(src, {
      width: 700
    });
  };

  $scope.imgix = function(src, w, h) {
    if (!src) return '';

    return imgix.url(src, {
      width: w || 100,
      height: h || 100
    });
  };

  $scope.isVenueState = function() {
    return $state.is('app.venueOld') || $state.is('app.venue');
  };
  $scope.isInfoState = function() {
    return $state.is('app.venue.info') || $state.is('app.venueOld.info');
  };
  $scope.isEventsState = function() {
    return $state.is('app.venue.events') || $state.is('app.venueOld.events');
  };

  $scope.goToEvents = function() {
    $state.go('app.venue.events', {
      seoPathname: $scope.venue.seoPathname
    });
  };

  $scope.goToAbout = function() {
    if ($scope.isVenueState()) {
      utilsService.scrollTo('venue-about-section', 100, 500);
    } else {
      $state.go('app.venue', {
        seoPathname: $scope.venue.seoPathname
      });
    }
  };

  $scope.scrollTo = function(target, $event) {
    if ($event) $event.preventDefault();
    utilsService.scrollTo(target, 100, 500);
  };

  $scope.goToEvent = function(event) {
    $state.go('app.event', {
      seoPathname: event.seoPathname || event.id
    });
  };

  $scope.goToImage = function(index) {
    $scope.venue.primaryImage = $scope.venue.images[index];
  };

  $scope.slideIndex = 0;

  jsSdkVenue.readById(venueIdOrSlug, {
    fields: 'name,seoPathname,details,tags,rating,images,location,schedule,favorites,website,phone,favoriteCount,trackingFacebookPixelId'
  }).then(function success(response) {
    // Load additional venue info
    _listInfo(response.id);

    fb.logEvent(fb.events().VIEWED_CONTENT, response.id);

    $scope.venue = response;

    if (config.NODE_ENV === 'production') {
      const fbqData = {
        content_type: 'product',
        content_ids: [
          $scope.venue.id
        ],
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        language: navigator.language
      };

      $window.fbq('init', '1606722376242558');
      $window.fbq('trackSingle', '1606722376242558', 'ViewContent', fbqData);

      if ($scope.venue.trackingFacebookPixelId) {
        $window.fbq('init', $scope.venue.trackingFacebookPixelId);
        $window.fbq('trackSingle', $scope.venue.trackingFacebookPixelId, 'ViewContent', fbqData);
      }
    }

    if (window.TablelistWidgets) {
      let inventoryListWidget;

      if (jQuery(window).width() < 992) {
        inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-xs');
      } else {
        inventoryListWidget = new window.TablelistWidgets.widgets.InventoryListWidget('#inventory-list-widget-lg');
      }

      inventoryListWidget.init({
        venueId: $scope.venue.id,
        theme: 'theme-light',
        client: $location.search().client || 'web',
        attributionId: jsSdkConfig.attributionId || 'TABLELIST',
        affiliateId: $rootScope.affiliateId,
        trackingId: $rootScope.trackingId,
        disableInlineCheckout: true,
        checkoutUrl: config.NODE_ENV === 'local' ? 'http://localhost:9090/buy' : null,
        onInventorySelected() {
          utilsService.scrollTo('venue-about-section', 100, 500);
        },
        onInventoryAddedToCart(inventory) {
          if (config.NODE_ENV === 'production') {
            const fbqData2 = {
              content_type: 'product',
              value: inventory.price,
              currency: 'USD',
              content_ids: [
                inventory.venue
              ],
              referrer: document.referrer,
              userAgent: navigator.userAgent,
              language: navigator.language
            };

            $window.fbq('init', '1606722376242558');
            $window.fbq('trackSingle', '1606722376242558', 'AddToCart', fbqData2);
          }
        }
      });
    }

    $scope.shareBarConfig = {
      url: utilsService.createUrl(`/v/${$scope.venue.seoPathname}`),
      message: `Join me at ${$scope.venue.name}`
    };

    $scope.showBookingWidget = true;

    $scope.openSentence = venueOpenSentence(response);

    $scope.venueImages = $scope.venue.images.map(function(image) {
      return {
        image: image.xlarge
      };
    });

    const venueTypeTag = _.find($scope.venue.tags, function(tag) {
      return tag.key === 'VENUE_TYPE';
    });
    const venueSubTypeTag = _.find($scope.venue.tags, function(tag) {
      return tag.key === 'VENUE_SUB_TYPE';
    });

    const musicTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'MUSIC';
    });

    const crowdTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'CROWD';
    });

    const noiseLevelTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'NOISE_LEVELS';
    });

    const okDressCodeTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'DRESS_CODE_OK';
    });

    const notOkDressCodeTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'DRESS_CODE_NOT_OK';
    });

    const goodForTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'GOOD_FOR';
    });

    const busyNightTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'BUSY_NIGHTS';
    });

    if (venueTypeTag) $scope.venue.venueType = venueTypeTag.name;
    if (venueSubTypeTag) $scope.venue.venueSubType = venueSubTypeTag.name;

    $scope.generateLink = function(link) {
      if (!link) return null;

      if (link.indexOf('http://') < 0 && link.indexOf('https://') < 0) {
        return `https://${link}`;
      }

      return link;
    };

    $scope.generateTwitterLink = function(link) {
      if (!link) return null;

      if (link.indexOf('https://twitter.com/') < 0 && link.indexOf('https://twitter.com/') < 0) {
        return `http://twitter.com/${link}`;
      }

      return link;
    };

    function venueOpenSentence(venue) {
      let today = new Date().getDay();
      const isAfterMidnight = new Date().getHours() < 6;

      if (isAfterMidnight) {
        today -= 1;

        if (today < 0) {
          today = 6;
        }
      }

      const todaysSchedule = _.find(venue.schedule, function(scheduleDay) {
        return scheduleDay.day === today;
      });

      if (!todaysSchedule) return '';

      if (todaysSchedule.closed) return 'CLOSED';

      let start = todaysSchedule.hours[0].start;
      let end = todaysSchedule.hours[0].end;

      if (!start || !end) return '';

      start = moment.utc(start);
      end = moment.utc(end);

      return $scope.getDayName(today) + ' ' + start.format('h:mm a') + ' - ' + end.format('h:mm a'); //eslint-disable-line
    }

    //tags
    if (musicTags && musicTags.length) {
      $scope.venue.musicTags = musicTags;
    }
    if (crowdTags && crowdTags.length) {
      $scope.venue.crowdTags = crowdTags;
    }
    if (noiseLevelTags && noiseLevelTags.length) {
      $scope.venue.noiseLevelTags = noiseLevelTags;
    }
    if (okDressCodeTags && okDressCodeTags.length) {
      $scope.venue.okDressCodeTags = okDressCodeTags;
    }
    if (notOkDressCodeTags && notOkDressCodeTags.length) {
      $scope.venue.notOkDressCodeTags = notOkDressCodeTags;
    }
    if (goodForTags && goodForTags.length) {
      $scope.venue.goodForTags = goodForTags;
    }
    if (busyNightTags && busyNightTags.length) {
      $scope.venue.busyNightTags = busyNightTags;
      _.each($scope.venue.busyNightTags, function(tag) {
        tag.name = $scope.getDayName(tag.name);
      });
    }
    $scope.venue.featuresTags = _.filter($scope.venue.tags, function(tag) {
      return tag.key === 'FEATURES';
    });

    //address and map stuff
    $scope.venue.address = response.location.address;
    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(response.location.address));

    if (response.location && response.location.address && response.location.address.address) {
      $scope.googleMapsDirectionsUrl = 'http://www.google.com/maps/dir//' + response.location.address.address.replace(/ /g, '+') + '+' + response.location.address.city + '+' + response.location.address.state + '+' + response.location.address.zip; //eslint-disable-line
    }

    $scope.getTimeFromCreation = function(creationDate) {
      return moment(creationDate).fromNow();
    };

    //set meta data and page title
    metaTagService.set({
      title: 'Buy Tickets and Tables at ' + $scope.venue.name, //eslint-disable-line
      description: 'Book VIP tables, customize bottle service, create a guest list, or purchase tickets for exclusive events at ' + $scope.venue.name + ' with Tablelist.', //eslint-disable-line
      facebookImage: _.get($scope, ['venue', 'primaryImage', 'xlarge']),
      deeplink: `venue/${$scope.venue.id}`,
      canonicalPath: `/v/${$scope.venue.seoPathname}`
    });

    _getEvents();
    _getCuratedLists($scope.venue.id);

  }, function error(response) {
    loggerService.error(response);

    $state.go('app.404', {
      message: 'Uh oh. The venue you are looking for is no longer available.'
    });
  });

  $scope.getDayName = utilsService.getDayName;
  $scope.getDayNameShort = utilsService.getDayNameShort;

  $scope.download = function() {
    utilsService.link(`//www.deeplink.me/tablelist.com/venue/${$scope.venueId}`);
  };

  function _getCuratedLists(venueId) {
    if (!venueId) return;

    jsSdkCuratedList.listByVenueId(venueId).then(function(resp) {
      $scope.curatedLists = resp;
    });
  }

  /* --------- EVENTS ---------- */

  $scope.eventPageSize = 10;
  $scope.eventPageNumber = 1;

  $scope.previousEventPage = function() {
    $scope.eventPageNumber -= 1;

    _getEvents(true);
  };

  $scope.nextEventPage = function() {
    $scope.eventPageNumber += 1;

    _getEvents(true);
  };

  $scope.resetEventPaging = function() {
    $scope.eventPageNumber = 1;
  };

  function _getEvents(page) {
    if (!page) {
      $scope.resetEventPaging();
    }

    $scope.loadingEvents = true;

    eventService.listByVenueId($scope.venue.id, {
        dateStart: dateUtils.toUTCTimestampWithoutTime(new Date()),
        sort: 'date',
        skip: ($scope.eventPageNumber - 1) * $scope.eventPageSize,
        limit: $scope.eventPageSize
      })
      .then(response => {
        $scope.$apply(() => {
          $scope.events = response.data;
          $scope.totalEvents = response.count;

          $scope.events = $scope.events.map(event => {
            event.venue = $scope.venue;

            return event;
          });

          $scope.loadingEvents = false;

          if (page) {
            utilsService.scrollTo('venue-about-section', 100, 500);
          }
        });
      });
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  '$state',
  '$stateParams',
  '$location',
  '$sce',
  'utilsService',
  'jsSdk.venue',
  'jsSdk.venueInfo',
  'jsSdk.event',
  'jsSdk.curatedList',
  'jsSdk.imgix',
  '$http',
  'modalService',
  '$filter',
  'tl.facebook',
  'loggerService',
  'favoritesService',
  'metaTagService',
  'trackingService',
  'jsSdk.config',
  'partnerService',
  '$window'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/venue/venueCtrl.js